import React from 'react';
import { useTranslation } from 'react-i18next';

interface TimeoutToastWithRetryProps {
  message: string;
  onRetry: () => void;
  onDismiss: () => void;
}

// Error Icon component
const ErrorIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-5 h-5 text-[#DC2626]"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="15" y1="9" x2="9" y2="15"></line>
    <line x1="9" y1="9" x2="15" y2="15"></line>
  </svg>
);

const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-5 h-5"
    aria-hidden="true"
  >
    <path d="M18 6 6 18"></path>
    <path d="m6 6 12 12"></path>
  </svg>
);

export const TimeoutToastWithRetry: React.FC<TimeoutToastWithRetryProps> = ({
  message,
  onRetry,
  onDismiss,
}) => {
  const handleRetry = () => {
    onRetry();
    onDismiss();
  };

  const { t } = useTranslation();

  return (
    <div
      className="flex items-center gap-3 bg-white rounded-ds-default px-4 py-3 min-h-[52px] w-auto mx-auto whitespace-nowrap"
      style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)' }}
    >
      {/* Error icon with colored background */}
      <div className="flex-shrink-0 bg-[#FEE2E2] rounded-full p-1">
        <ErrorIcon />
      </div>

      {/* Message */}
      <p className="flex-1 text-[#111827]">{message}</p>

      {/* Retry button */}
      <button
        onClick={handleRetry}
        className="flex-shrink-0 px-3 py-1.5 bg-[#DC2626] text-white rounded hover:bg-[#B91C1C] transition-colors text-sm font-medium"
      >
        {t('retry')}
      </button>

      {/* Close button */}
      <button
        className="flex-shrink-0 text-ds-text-tertiary hover:text-ds-text-secondary transition-colors"
        onClick={onDismiss}
        aria-label={t('closeNotification')}
      >
        <CloseIcon />
      </button>
    </div>
  );
};
